import { render, staticRenderFns } from "./MasterSparepart.vue?vue&type=template&id=3c62c1ba&scoped=true"
import script from "./MasterSparepart.vue?vue&type=script&lang=js"
export * from "./MasterSparepart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c62c1ba",
  null
  
)

export default component.exports